import {
  Breadcrumbs,
  filtersToGraphQLFilters,
  HeaderWithScrollables,
  IFlow,
  IWorkCompany,
  LOCAL_STORAGE_DASHBOARD_VIEW_MODE_KEY,
  localForageUtil,
  makeDynamicReportingPageStore,
  PageViewModeEnum,
  PageViewModeToolbar,
} from '@diana/core';
import { useIsFetching } from '@tanstack/react-query';
import { Fragment } from 'react';
import { useBreadcrumbsRoot } from '../../hooks/useBreadcrumbsRoot';
import { BuilderButton } from './BuilderButton';
import { getReportingGraphQLWorksQueryKey } from './Support';

export function Header(props: IHeaderProps) {
  const {
    flows,
    reportId,
    layoutDisplayName,
    setIsExportModalOpen,
    componentsLength,
    companies,
    layoutCompanyId,
  } = props;
  const breadcrumbRoot = useBreadcrumbsRoot('performance');
  const breadcrumbs = [breadcrumbRoot, { title: layoutDisplayName || '', link: '' }];

  const useStore = makeDynamicReportingPageStore(reportId);
  const viewMode = useStore((store) => store.viewMode);
  const filtersValues = useStore((store) => store.filtersValues);
  const availableFilters = useStore((store) => store.availableFilters);
  const setViewMode = useStore((store) => store.setViewMode);

  const onViewChange = (viewMode: PageViewModeEnum) => {
    localForageUtil
      .setItem({
        key: `${LOCAL_STORAGE_DASHBOARD_VIEW_MODE_KEY}-${reportId}`,
        value: viewMode,
      })
      .then((storedViewMode) => {
        storedViewMode && setViewMode(storedViewMode);
      });
  };

  const isFetchingWorks = useIsFetching({
    queryKey: getReportingGraphQLWorksQueryKey({
      reportId,
      graphQLFilters: filtersToGraphQLFilters({
        filters: availableFilters,
        filtersValues,
      }),
    }),
  });

  return (
    <HeaderWithScrollables
      left={<Breadcrumbs items={breadcrumbs} />}
      right={
        <Fragment>
          <BuilderButton reportId={reportId} />
          {flows ? (
            <PageViewModeToolbar
              layoutCompanyId={layoutCompanyId}
              reportId={reportId}
              companies={companies}
              shouldRenderShareButton
              showViewModeButtons={!!componentsLength}
              viewMode={viewMode}
              onViewChange={onViewChange}
              isCsvButtonDisabled={isFetchingWorks > 0}
              onCsvClick={
                viewMode === PageViewModeEnum.Table
                  ? () => setIsExportModalOpen?.(true)
                  : !componentsLength
                  ? () => setIsExportModalOpen?.(true)
                  : undefined
              }
            />
          ) : null}
        </Fragment>
      }
    />
  );
}

interface IHeaderProps {
  reportId: string;
  flows?: IFlow[];
  companies?: IWorkCompany[];
  layoutDisplayName?: string;
  setIsExportModalOpen?: (state: boolean) => void;
  componentsLength?: number;
  hasDifferentDataSource?: boolean;
  layoutCompanyId?: string;
}
